import React from "react";
import ReactGA from "react-ga";
import EventBus from "../eventbus/EventBus";
import { dropsFilesUrl } from "../Globals";
const yaml = require("js-yaml");

const defaultState = {
  src: `${dropsFilesUrl}/commands/SharpHound.yaml`,
  languages: [],
  params: [],
  flags: [],
  savedParams: {},
  rendered: {
    rendered: {},
    selectedOpt: [],
  },
  sigmaRulesURL: '',
  sections: [],
  labels: [],
  breadcrumbs: [],
  hasError: false,
};

export const CommandContextStore = React.createContext(defaultState);

const calculateNewState = (state, action) => {
  switch (action.type) {
    case "UPDATE_TOOL_DATA":
      // console.log("tool data updated");
      return { ...state, ...action.data, hasError: false };
    case "UPDATE_PARAMS":
      // console.log("**Saved new Params***");
      let savedParams = { ...state.savedParams, ...action.data.saved };
      localStorage.setItem("SavedParams", JSON.stringify(savedParams));
      return {
        ...state,
        savedParams: savedParams,
        rendered: action.data.rendered,
      };
    case "CLEAR_PARAMS":
      localStorage.setItem("SavedParams", "");
      return { ...state, savedParams: {} };
    case "UPDATE_SRC":
      ReactGA.event({
        category: "Tools",
        action: "Use tool",
        label: action.data,
      });
      //getCommandInfoOut(action.data);
      // ReactGA.pageview(action.data);
      return { ...state, src: `${dropsFilesUrl}/${action.data}` };
    case "COPIED":
      return { ...state, copied: action.data };
    case "UPDATE_LABELS":
      return { ...state, labels: action.data };
    case "PUBLISH_ERROR":
      return { ...state, hasError: true };
    default:
      break;
  }
};

const reducer = (state, action) => {
  let newState = calculateNewState(state, action);
  return newState;
};

const tmpFunc = (initState) => {
  // On component first load
  const queryParams = new URLSearchParams(window.location.search);
  try {
    let labeslURL = queryParams.get("labels");

    if (labeslURL !== "") {
      initState.labels = labeslURL.split(",");
    }
  } catch {
    // No search params were supplied, nothing to do
  }

  try {
    let toolName = queryParams.get("tool");

    if (toolName !== "" && toolName !== null) {
      initState.src = `${dropsFilesUrl}/commands/${toolName}.yaml`;
    }
  } catch {
    // No search params were supplied, nothing to do
  }

  try {
    initState.savedParams = JSON.parse(localStorage.getItem("SavedParams"));
  } catch {
    // No saved params were supplied in local storage
  }

  return initState;
};

export const CommandContext = ({ children }) => {
  // const [state, dispatch] = React.useReducer(reducer, {});
  const [state, dispatch] = React.useReducer(reducer, defaultState, tmpFunc);

  const getCommandInfo = (src) => {
    let toolData = {};
    if (src === "") return;
    EventBus.publish("SHOW_LOADING");
    toolData.breadcrumbs = src.split(".")[0].split("/").slice(1);
    // Get commands file and update sections and params
    fetch(src)
      // .then(resp => resp.json())
      .then((resp) => {
        return resp.text();
      })
      .then((data) => {
        try{
          data = yaml.safeLoad(data);
        } catch {
          dispatch({ type: "PUBLISH_ERROR", data: {} });
        }
        if (typeof data.projectLink !== undefined) {
          toolData.projectLink = data.projectLink;
        }
        toolData.params =
          data.params !== null && data.params !== undefined ? data.params : [];
        toolData.flags = data.flags;
        toolData.sections = data.sections;
        toolData.languages = data.languages;
        toolData.sigmaRulesURL = data?.sigmaRulesURL
        if (toolData.sections === undefined) {
          dispatch({ type: "PUBLISH_ERROR", data: {} });
        } else {
          dispatch({ type: "UPDATE_TOOL_DATA", data: toolData });
        }
        EventBus.publish("HIDE_LOADING");
      });
  };

  React.useEffect(() => {
    // Changed tool refernce by command navigation
    if (undefined != state.src) {
      getCommandInfo(state.src);
    }
  }, []);

  React.useEffect(() => {
    // Changed tool refernce by command navigation
    if (undefined != state.src) {
      getCommandInfo(state.src);
    }
  }, [state.src]);

  return (
    <CommandContextStore.Provider value={{ ...state, dispatch }}>
      {children}
    </CommandContextStore.Provider>
  );
};

//export default CommandContext;
